<template>
    <v-container class="panelgrid">
        <v-row v-if="loading" class="justify-center align-center">
            <v-progress-circular :size="35"
                                 color="primary"
                                 indeterminate />
        </v-row>
        <v-row class="title">
            <v-col>
                <span v-if="!editing">Ativos - cadastro de fundo de investimento.</span>
                <span v-else>Editar ativo {{ pair.asset.idAtivo }} - {{ pair.investmentFund.cnpj }}</span>
            </v-col>
        </v-row>
        <v-form class="fields"
                v-model="is_valid"
                :disabled="loading">
            <v-row>
                <v-col cols="8">
                    <v-text-field label="Descrição"
                                  v-model.trim="description"
                                  :rules="[validateDescription]"
                                  placeholder="Descrição"></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field label="CNPJ"
                                  :rules="[validateDocument]"
                                  v-model.trim="f_cnpj"
                                  @keypress="keyFilter.onlyDigits"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-autocomplete v-model="emissor"
                                    :items="entities"
                                    item-text="fullName"
                                    item-value="entityId"
                                    label="Emissor"
                                    placeholder="Emissor"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="gestor"
                                    :items="gestores"
                                    item-text="razaoSocial"
                                    item-value="idGestor"
                                    :rules="[(v) => required(v) || 'Gestor obrigatório']"
                                    label="Gestor"
                                    placeholder="Gestor"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="estrategia"
                                    :items="strats"
                                    item-text="name"
                                    item-value="id"
                                    :rules="[(v) => required(v) || 'Estratégia obrigatória']"
                                    label="Estratégia"
                                    placeholder="Estratégia"
                                    @change="changeStrat"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-autocomplete v-model="ireferencia"
                                    :items="listrefs"
                                    item-text="descricao"
                                    item-value="idIreferencia"
                                    :rules="[(v) => required(v) || 'Índice de referência obrigatório']"
                                    label="Índice de referência"
                                    placeholder="Índice de referência"
                                    @change="changeIRef"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="tributacao"
                                    :items="fTributacoes"
                                    label="Forma de tributação"
                                    placeholder="Forma de tributação"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="c_anbima"
                                    :items="anbimas"
                                    :rules="[(v) => required(v) || 'Classe ANBIMA obrigatória']"
                                    label="Classe ANBIMA"
                                    placeholder="Classe ANBIMA"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-autocomplete v-model="forma_gestao"
                                    :items="fGestao"
                                    label="Forma de gestão"
                                    placeholder="Forma de gestão"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="fgc"
                                    :items="bitVals"
                                    item-text="name"
                                    item-value="value"
                                    :rules="[(v) => required(v) || 'FGC obrigatório']"
                                    label="FGC"
                                    placeholder="FGC"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model.trim="politica"
                                  :rules="[(v) => required(v) || 'Política obrigatória']"
                                  label="Política"
                                  placeholder="Política"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-autocomplete v-model="gestao"
                                    :items="tGestao"
                                    :rules="[(v) => required(v) || 'Tipo de gestão obrigatório']"
                                    label="Tipo de gestão"
                                    placeholder="Tipo de gestão"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="tipo_remuneracao"
                                    :items="tsRemuneracao"
                                    item-text="descricao"
                                    item-value="idTremuneracao"
                                    :rules="[(v) => required(v) || 'Tipo de remuneração obrigatório']"
                                    label="Tipo de remuneração"
                                    placeholder="Tipo de remuneração"></v-autocomplete>
                </v-col>
                <v-col cols="4">
                    <v-autocomplete v-model="indexador"
                                    :items="indexadores"
                                    item-text="descricao"
                                    item-value="idIndexador"
                                    :rules="[(v) => required(v) || 'Indexador obrigatório']"
                                    label="Indexador"
                                    placeholder="Indexador"
                                    @change="changeIndex"></v-autocomplete>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-text-field v-model.trim="cotas_aplicacao"
                                  label="Cotas da aplicação"
                                  placeholder="Cotas da aplicação"></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model.trim="cotas_resgate"
                                  label="Cotas do resgate"
                                  placeholder="Cotas do resgate"></v-text-field>
                </v-col>
                <v-col cols="4">
                    <v-text-field v-model.trim="credito_resgate"
                                  label="Crédito no resgate"
                                  placeholder="Crédito no resgate"></v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="4">
                    <v-checkbox v-model="liquidez"
                                label="Liquidez"></v-checkbox>
                </v-col>
                <v-col cols="4">
                    <v-checkbox v-model="isento_ir"
                                label="Isento de IR"></v-checkbox>
                </v-col>
                <v-col cols="4">
                    <v-checkbox v-model="tem_evento"
                                label="Tem evento"></v-checkbox>
                </v-col>
            </v-row>
            <v-row class="btn-panel">
                <v-col cols="4">
                    <v-btn class="btn-ok"
                           :disabled="loading || !is_valid"
                           @click="saveData">Gravar</v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn class="btn-clean"
                           :disabled="loading"
                           @click="clearFields">Limpar</v-btn>
                </v-col>
                <v-col cols="4">
                    <v-btn class="btn-search"
                           :disabled="loading"
                           @click="searching=true">Pesquisar</v-btn>
                </v-col>
            </v-row>
        </v-form>
        <SearchInvestmentFund v-if="searching"
                              @selected="setupPair"
                              @close="searching = false"></SearchInvestmentFund>
    </v-container>
</template>

<style>
</style>

<style lang="css" scoped>
.panelgrid {
    margin: 0;
    padding: 1em;
    overflow-y: auto;
    min-height: 100%;
    max-height: 100%;
    height: 100%;
    width: 100%;
    min-width: 100%;
}
.btn-panel .col {
    align-items: center;
    text-align: center;
}
.btn-panel .col button {
    width: 50%;
    border-radius: 10px;
    font-weight: bold;
    color: white;
    font-size: 1rem;
}
.btn-panel .col button.btn-ok {
    background-color: rgba(0,164,0,0.75);
}
.btn-panel .col button.btn-clean {
    background-color: rgba(196,64,96,0.75);
}
.btn-panel .col button.btn-search {
    background-color: rgba(196,96,64,0.75);
}
</style>

<script lang="js">
import client               from '../../../services/AdminService';
import SearchInvestmentFund from './components/SearchInvestmentFund.vue';
import idFormatter          from '@/services/IdValueFormatter';
import keyFilter            from '@/utils/filter';

const LABEL_ENTITIES        = 'assets_entities';
const LABEL_GESTORES        = 'assets_gestores';
const LABEL_IREFS           = 'assets_irefs';
const LABEL_TSREMUNER       = 'assets_tsremuneracao';
const LABEL_INDEXADORES     = 'assets_indexadores';

export default              {
    data                    () {
        return              {
            client,
            loading         : false,
            is_valid        : false,
            changing        : false,
            searching       : false,
            editing         : false,
            pair            : undefined,

            idFormatter,
            keyFilter,

            entities        : [],
            gestores        : [],
            irefs           : [],
            listrefs        : [],
            tsRemuneracao   : [],
            indexadores     : [],
            fTributacoes    : [
                'N/D',
                'ISENTO',
                'S',
                'N'
            ],
            fGestao         : [
                'N/D',
                'PASSIVA',
                'ATIVA E NÃO-REFERENCIADA',
                'ATIVA E REFERENCIADA',
                'ENHANCED'
            ],
            tGestao         : [
                'N/D',
                'FI',
                'FIDEBICENT',
                'FIPREV'
            ],
            bitVals         : [
                { name: 'Não', value: 0 },
                { name: 'Sim', value: 1 }
            ],
            anbimas         : [
                'Fundo de Ações',
                'Fundo Cambial',
                'Fundo de Renda Fixa',
                'Fundo Multimercado',
                'Previdência',
                'Fundos Imobiliários'
            ],
            strats          : [
                {"id":7,"name":"N\/D"},
                {"id":1,"name":"Juros Pré (Fixo)"},
                {"id":2,"name":"Juros Pós (CDI)"},
                {"id":3,"name":"Juros Pós (Inflação)"},
                {"id":4,"name":"Renda Variável"},
                {"id":5,"name":"Câmbio"},
                {"id":6,"name":"Livre"}
            ],

            description     : undefined,
            cnpj            : undefined,
            gestor          : undefined,
            emissor         : undefined,
            custodiante     : undefined,
            estrategia      : undefined,
            ireferencia     : undefined,
            indexador       : undefined,
            c_anbima        : undefined,
            gestao          : undefined,
            fgc             : undefined,
            tributacao      : undefined,
            cotas_aplicacao : undefined,
            cotas_resgate   : undefined,
            credito_resgate : undefined,
            politica        : undefined,
            forma_gestao    : undefined,
            tipo_remuneracao: undefined,
            liquidez        : undefined,
            isento_ir       : undefined,
            tem_evento      : undefined
        }
    },
    components              : { SearchInvestmentFund },
    methods                 : {
        async loadCache     () {
            const defErrMsg = 'Falha não identificada ao carregar entidades';
            this.loading = true;
            try {
                try {
                    this.entities.length = 0;
                    const prev  = this.hydrateEntities();
                    if (prev && prev.length) {
                        this.entities.push(...prev);
                    } else {
                        let ents = await this.client.getEntities();
                        if (!ents.success) {
                            this.$toast.error(ents.message || defErrMsg);
                        } else {
                            this.entities.push(...ents.content);
                            this.persistEntities(ents.content);
                        }
                    }
                } catch (e) {
                    this.$toast.error(e && e.message || defErrMsg);
                }
                try {
                    this.gestores.length = 0;
                    const antr = this.hydrateGestores();
                    if (antr && antr.length) {
                        this.gestores.push(...antr);
                    } else {
                        let gest = await this.client.getGestores();
                        if (!gest.success) {
                            this.$toast.error(gest.message || defErrMsg);
                        } else {
                            this.gestores.push(...gest.content);
                            this.persistGestores(gest.content);
                        }
                    }
                } catch (e) {
                    this.$toast.error(e && e.message || 'Falha não identificada ao carregar entidades');
                }
                try {
                    this.irefs.length = 0;
                    const pref = this.hydrateIRefs();
                    if (pref && pref.length) {
                        this.irefs.push(...pref);
                    } else {
                        let pref = await this.client.getIRefs();
                        if (!pref.success) {
                            this.$toast.error(pref.message || defErrMsg);
                        } else {
                            this.irefs.push(...pref.content);
                            this.persistIRefs(pref.content);
                            this.changeStrat();
                        }
                    }
                } catch (e) {
                    this.$toast.error(e && e.message || 'Falha não identificada ao carregar entidades');
                }
                try {
                    this.tsRemuneracao.length = 0;
                    const tsrem = this.hydrateTsRemuner();
                    if (tsrem && tsrem.length) {
                        this.tsRemuneracao.push(...tsrem);
                    } else {
                        let tsrem = await this.client.getTsRemuneracao();
                        if (!tsrem.success) {
                            this.$toast.error(tsrem.message || defErrMsg);
                        } else {
                            this.tsRemuneracao.push(...tsrem.content);
                            this.persistTsRemuner(tsrem.content);
                        }
                    }
                } catch (e) {
                    this.$toast.error(e && e.message || 'Falha não identificada ao carregar entidades');
                }
                try {
                    this.indexadores.length = 0;
                    const idx = this.hydrateIndexadores();
                    if (idx && idx.length) {
                        this.indexadores.push(...idx);
                    } else {
                        let idx = await this.client.getIndexadores();
                        if (!idx.success) {
                            this.$toast.error(idx.message || defErrMsg);
                        } else {
                            this.indexadores.push(...idx.content);
                            this.persistIndexadores(idx.content);
                        }
                    }
                } catch (e) {
                    this.$toast.error(e && e.message || 'Falha não identificada ao carregar entidades');
                }
            } finally {
                this.loading = false;
            }
        },
        async saveData      () {
            const asset     = this.buildAsset();
            const fund      = this.buildFund();
            try {
                const resp  = await this.client.saveInvestmentFund(asset, fund);
                if (!resp.success) {
                    this.$toast.error(resp.message || 'Falha ao gravar novo fundo.');
                } else {
                    this.$toast.info(resp.message || 'Gravado com sucesso.');
                    this.clearFields();
                }
            } catch (e) {
                this.$toast.error(e.message || 'Falha não identificada');
            }
        },
        clearFields         () {
            this.searching       = false;
            this.editing         = false;
            this.pair            = undefined;
            this.description     = undefined;
            this.cnpj            = undefined;
            this.gestor          = undefined;
            this.emissor         = undefined;
            this.custodiante     = undefined;
            this.estrategia      = undefined;
            this.ireferencia     = undefined;
            this.indexador       = undefined;
            this.c_anbima        = undefined;
            this.gestao          = undefined;
            this.fgc             = undefined;
            this.tributacao      = undefined;
            this.cotas_aplicacao = undefined;
            this.cotas_resgate   = undefined;
            this.credito_resgate = undefined;
            this.politica        = undefined;
            this.forma_gestao    = undefined;
            this.tipo_remuneracao= undefined;
            this.liquidez        = undefined;
            this.isento_ir       = undefined;
            this.tem_evento      = undefined;
        },
        buildAsset          () {
            if (this.editing) {
                const asset           = this.pair.asset;
                asset.idEntidade      = this.emissor && +this.emissor || 0;
                asset.idCustodiante   = undefined;
                asset.idIreferencia   = +this.ireferencia;
                asset.idIndexador     = +this.indexador;
                asset.fgc             = +this.fgc;
                asset.descricao       = this.description;
                asset.idEstrategia    = +this.estrategia;
                asset.idTremuneracao  = +this.tipo_remuneracao;
                asset.liquidez        = this.liquidez ? 1 : 0;
                asset.isentoIr        = this.isento_ir ? 1 : 0;
                asset.temEvento       = this.tem_evento ? 1 : 0;
                asset.codigo          = this.cnpj && this.cnpj.replace(/[^\d]/g, '');
                return asset;
            }
            return              {
                idTproduto      : 8,
                idEntidade      : this.emissor && +this.emissor || 0,
                idCustodiante   : undefined,
                idIreferencia   : +this.ireferencia,
                idIndexador     : +this.indexador,
                fgc             : +this.fgc,
                descricao       : this.description,
                idEstrategia    : +this.estrategia,
                idTremuneracao  : +this.tipo_remuneracao,
                liquidez        : this.liquidez ? 1 : 0,
                isentoIr        : this.isento_ir ? 1 : 0,
                temEvento       : this.tem_evento ? 1 : 0,
                codigo          : this.cnpj && this.cnpj.replace(/[^\d]/g, ''),
                fullname        : `${this.cnpj}-${this.description}`.substring(0, 50)
            }
        },
        buildFund           () {
            if (this.editing) {
                const fund           = this.pair.investmentFund;
                fund.cnpj            = this.cnpj && this.cnpj.replace(/[^\d]/g, '');
                fund.idGestor        = +this.gestor;
                fund.classeAmbima    = this.c_anbima;
                fund.politica        = this.politica;
                fund.tipoGestao      = this.gestao;
                fund.formaTributacao = this.tributacao;
                fund.formasGestao    = this.forma_gestao;
                fund.cotaAplicacao   = this.cotas_aplicacao;
                fund.cotaResgate     = this.cotas_resgate;
                fund.creditoResgate  = this.credito_resgate;
                return fund;
            }
            return              {
                cnpj            : this.cnpj && this.cnpj.replace(/[^\d]/g, ''),
                idGestor        : +this.gestor,
                classeAmbima    : this.c_anbima,
                politica        : this.politica,
                tipoGestao      : this.gestao,
                formaTributacao : this.tributacao,
                formasGestao    : this.forma_gestao,
                cotaAplicacao   : this.cotas_aplicacao,
                cotaResgate     : this.cotas_resgate,
                creditoResgate  : this.credito_resgate
            }
        },
        setupPair           (obj) {
            this.editing    = !!obj;
            this.pair       = obj;
            if (this.editing) {
                const { asset, investmentFund } = obj;
                this.emissor            = asset.idEntidade;
                this.ireferencia        = asset.idIreferencia;
                this.emissor            = asset.idEntidade;
                this.ireferencia        = asset.idIreferencia;
                this.indexador          = asset.idIndexador;
                this.fgc                = asset.fgc;
                this.description        = asset.descricao;
                this.estrategia         = asset.idEstrategia;
                this.tipo_remuneracao   = asset.idTremuneracao;
                this.liquidez           = asset.liquidez  === 1;
                this.isento_ir          = asset.isentoIr  === 1;
                this.tem_evento         = asset.temEvento === 1;
                this.cnpj               = asset.codigo || investmentFund.cnpj;
                this.gestor             = investmentFund.idGestor;
                this.c_anbima           = investmentFund.classeAmbima;
                this.politica           = investmentFund.politica;
                this.gestao             = investmentFund.tipoGestao;
                this.tributacao         = investmentFund.formaTributacao;
                this.forma_gestao       = investmentFund.formasGestao;
                this.cotas_aplicacao    = investmentFund.cotaAplicacao;
                this.cotas_resgate      = investmentFund.cotaResgate;
                this.credito_resgate    = investmentFund.creditoResgate;
            }
            this.searching  = false;
        },
        required            (v) { return v !== null && v !== undefined },
        requiredTruthy      (v) { return !!v; },
        validCnpj           (v) {
            if (!v) { return false }
            v = v.replace(/[^\d]/g, '');
			if((!v) || (v.length !== 14)) { return false }
			let d = v.substr(0, 12), c = v.substr(12), t = 0, c1, c2, i;
			for (i = 0; i <  4; i++) { t += parseInt(d.charAt(i)) * ( 5 - i) }
			for (i = 4; i < 12; i++) { t += parseInt(d.charAt(i)) * (13 - i) }
			if(!t) { return false }
			c1 = 11 - (t % 11); if (c1 > 9) { c1 = 0 }
			if((''+c1) !== c.charAt(0)) { return false }
			t = 2 * c1;
			for (i = 0; i <  5; i++) { t += parseInt(d.charAt(i)) * ( 6 - i) }
			for (i = 5; i < 12; i++) { t += parseInt(d.charAt(i)) * (14 - i) }
			c2 = 11 - (t % 11); if(c2 > 9) { c2 = 0 }
			return (''+c2) === c.charAt(1)
        },
        maxLength           (v, l) {
            if (!v || (l <= 0)) { return true; }
            return v.length <= l;
        },
        validateDescription (v) {
            if (!(v && this.requiredTruthy(v = v.trim()))) {
                return 'Valor obrigatório.';
            }
            if (!this.maxLength(v, 100)) {
                return 'Máximo de 100 caracteres.';
            }
            return true;
        },
        validateDocument    (v) {
            if (!(v && this.requiredTruthy(v = v.trim()))) {
                return 'Valor obrigatório.';
            }
            if (!this.validCnpj(v)) {
                return 'CNPJ inválido';
            }
            return true;
        },
        changeStrat         () {
            const prev = this.ireferencia;
            this.listrefs.length = 0;
            const filter    = this.irefs.filter((ir) => ir.idEstrategia === this.estrategia);
            if (filter.length) {
                this.listrefs.push(...filter);
            } else {
                this.listrefs.push(...this.irefs.filter((ir) => !ir.idEstrategia));
            }
            if (!this.listrefs.some((r) => r.idIreferencia === prev)) {
                this.ireferencia = undefined;
            }
            if ([0, 6, 7, 8].indexOf(this.estrategia) >= 0) { return; }
            this.changeIRef();
        },
        changeIRef          () {
            if (this.changing) { return; }
            this.indexador = undefined;
            if (!(this.ireferencia)) {
                return;
            }
            const idx = this.indexadores.filter((r) => r.idIReferencia === this.ireferencia)[0];
            if (!idx) { return; }
            const strat = this.strats.filter((r) => r.idEstrategia === idx.idEstrategia)[0];
            if (strat || !this.estrategia) {
                this.indexador = idx.idIndexador;
            }
        },
        changeIndex         () {
            if (!this.indexador || this.changing) { return; }
            if ([0, 1, 10].indexOf(this.indexador) >= 0) { return; }
            try {
                this.changing = true;
                const target = this.indexadores.filter((r) => r.idIndexador === this.indexador)[0];
                if (target) {
                    const iref = target.idIReferencia;
                    const mark = this.irefs.filter((r) => r.idIreferencia === iref)[0];
                    if (mark) {
                        this.estrategia = mark.idEstrategia;
                        this.changeStrat();
                        this.ireferencia = iref;
                    }
                }
            } finally {
                this.changing = false;
            }
        },
        persistEntities     (a) {
            sessionStorage.setItem(LABEL_ENTITIES, a && a.length ? JSON.stringify(a) : '[]')
        },
        hydrateEntities     () {
            const text      = sessionStorage.getItem(LABEL_ENTITIES);
            return          text && JSON.parse(text) || undefined;
        },
        persistGestores     (a) {
            sessionStorage.setItem(LABEL_GESTORES, a && a.length ? JSON.stringify(a) : '[]')
        },
        hydrateGestores     () {
            const text      = sessionStorage.getItem(LABEL_GESTORES);
            return          text && JSON.parse(text) || undefined;
        },
        persistIRefs        (a) {
            sessionStorage.setItem(LABEL_IREFS, a && a.length ? JSON.stringify(a) : '[]')
        },
        hydrateIRefs        () {
            const text      = sessionStorage.getItem(LABEL_IREFS);
            return          text && JSON.parse(text) || undefined;
        },
        persistTsRemuner    (a) {
            sessionStorage.setItem(LABEL_TSREMUNER, a && a.length ? JSON.stringify(a) : '[]')
        },
        hydrateTsRemuner    () {
            const text      = sessionStorage.getItem(LABEL_TSREMUNER);
            return          text && JSON.parse(text) || undefined;
        },
        persistIndexadores  (a) {
            sessionStorage.setItem(LABEL_INDEXADORES, a && a.length ? JSON.stringify(a) : '[]')
        },
        hydrateIndexadores  () {
            const text      = sessionStorage.getItem(LABEL_INDEXADORES);
            return          text && JSON.parse(text) || undefined;
        },
        formatCNPJ          (e) {
            const key       = e.key;
            switch (key) {
            }
        }
    },
    computed                : {
        f_cnpj              : {
            get : function () {
                return this.idFormatter.format(1, this.cnpj);
            },
            set : function (v) {
                this.cnpj = this.idFormatter.clear(1, v);
            }
        }
    },
    created                 () {
    },
    mounted                 () {
        return this.loadCache();
    },
    beforeDestroy           () {
        sessionStorage.removeItem(LABEL_ENTITIES);
        sessionStorage.removeItem(LABEL_GESTORES);
        sessionStorage.removeItem(LABEL_IREFS);
        sessionStorage.removeItem(LABEL_TSREMUNER);
        sessionStorage.removeItem(LABEL_INDEXADORES);
    }
}
</script>